<template>
  <div class="container-fluid">
    <Card>
      <template slot="header">
        <h3>گزارش قراردادهای بدون فاکتور</h3>
        <hr />
      </template>
      <template slot="content">
        <div class="container-fluid p-2" id="NoFactor">
          <div class="row">
            <div class="col-lg-4 col-12">
            <small id="LblTaskDate">از تاریخ شروع قرارداد  </small>
            <date-picker input-class="required form-control" color="dimgray" v-model="Data.DateAz"  clearable :editable="true" placeholder="از تاریخ"></date-picker>
          </div>
          <div class="col-lg-4 col-12">
            <small id="LblTaskDate">تا تاریخ شروع قرارداد</small>
            <date-picker input-class="required form-control" color="dimgray" v-model="Data.DateTa" clearable :editable="true" placeholder="تا تاریخ"></date-picker>
          </div>
          <div class="col-lg-2 col-12">
            <button class="btn btn-success w-100 mt-4" @click="GetData()"> جستجو</button>
          </div>
          </div>
          <div class="row">
            <div class="col-12">
              <BnpGrid
                Selectable=""
                :action="true"
                :IsReport="true"
                :ListCommaReport="['Amount', 'TotallAmount', 'Discount', 'Tax', 'Toll']"
                :HeaderReport="'گزارش قراردادهای بدون فاکتور'"
                :Sortable="true"
                :propsRows="propsRows"
                :propsColumn="propsColumn"
                :NoRowNum="false" 
                :hasRowNum="true" 
                :pagenum="20" 
                v-if="$store.state.renderComponentGrid"
              >
                <template slot="Amount" slot-scope="props">
                  <span class="font-smaller"> {{ $Comma3ragham(props.props.Amount) }}</span>
                </template>
                <template slot="TotallAmount" slot-scope="props">
                  <span class="font-smaller"> {{ $Comma3ragham(props.props.TotallAmount) }}</span>
                </template>
                <template slot="Discount" slot-scope="props">
                  <span class="font-smaller"> {{ $Comma3ragham(props.props.Discount) }}</span>
                </template>
                <template slot="Tax" slot-scope="props">
                  <span class="font-smaller"> {{ $Comma3ragham(props.props.Tax) }}</span>
                </template>
                <template slot="Toll" slot-scope="props">
                  <span class="font-smaller"> {{ $Comma3ragham(props.props.Toll) }}</span>
                </template>
                <template slot="action-slot" slot-scope="props">
                  <input type="checkbox" :checked="ToFacrotList.find((x) => x.Id == props.props.Id) == null ? false : true" :id="'check' + props.props.id" @click="checkContracts(props.props)" />
                  <a href="javascript:;" class="mr-2 badge" @click="OnDetail(props.props)" title="مشاهده بدهکاری"><h6><span class="fad fa-info-circle hover-info"></span></h6></a>
                  <a href="javascript:;" class="mr-2 badge" @click="GoCustomer(props.props)" title="مشاهده مشتری"><h6><span class="fas fa-eye font-weight-bold hover-danger"></span></h6></a>
                  
                </template>
              </BnpGrid>
            </div>
            <div class="col-lg-8 col-12"></div>
            <div class="col-lg-4 col-12">
              <button v-if="$session.get('Menu').filter((x) => x.RouteName == 'Factor')[0].isMojaz == 1" class="btn btn-info w-100 mt-2" :disabled="ToFacrotList.length < 1" @click="ToFactor">صدور فاکتور</button>
            </div>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

export default {
  data() {
    return {
      ToFacrotList: [],
      propsRows: [],
      propsColumn: [
        { name: 'CustomerName', label: 'نام مشتری', visibility: true },
        { name: 'ProductName', label: 'نام محصول', visibility: true },
        { name: 'TblContractId', label: 'شمار قرارداد', visibility: true },
        { name: 'Amount', label: 'قیمت', visibility: true },
        { name: 'Toll', label: 'عوارض', visibility: true },
        { name: 'Tax', label: 'مالیات', visibility: true },
        { name: 'Discount', label: 'تخفیف', visibility: true },
        { name: 'TotallAmount', label: 'قیمت کل', visibility: true },
      ],
      Data: { DateTa: '', DateAz: '' },
    }
  },
  created() {
    this.Data.DateAz='1401/01/01'
    this.Data.DateTa=this.$store.state.JalaliDate
  },
  mounted(){
    this.GetData()
  },
  methods: {
    GoCustomer(data){
      // this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: data.TblCustomerId } })
      this.$FindeCustomerById('DetailCustomer',data.TblCustomerId,false,null)
    },
    OnDetail(data){
      console.log(data);
      this.$CalcBedehiCustomer(data.TblCustomerId).then((result) => {
        if(result[0]!=null){
        this.$toasted.error('میزان بدهی مشتری : '+ this.$Comma3ragham(result[0].Remember), {
          action: {
              text: 'بستن',
              onClick: (e, toastObject) => {
              toastObject.goAway(0)
              },
          },
          })
        }
      })
    },
    GetData() {
      var DataAxios = { Method: 'POST', Action: 'Reports/NoFactorProducts', ArryfildValue: this.Data }
      this.$PostData(DataAxios).then((result) => {
        this.propsRows = result.data
        this.$store.state.renderComponentGrid = false
        this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true
        })
      })
    },
    checkContracts(data) {
      if (this.ToFacrotList.length > 0) {
        var temp = -1
        for (let index = 0; index < this.ToFacrotList.length; index++) {
          const element = this.ToFacrotList[index]
          if (data.Id == element.Id) {
            temp = index
          }
        }
        if (temp >= 0) {
          this.ToFacrotList.splice(temp, 1)
          document.getElementById('check' + data.Id).checked = false
        } else {
          if (this.ToFacrotList[0].TblContractId == data.TblContractId) {
            this.ToFacrotList.push(data)
          } else {
            document.getElementById('check' + data.id).checked = false
            this.$toasted.error('محصولات انتخابی برای ثبت فاکتور باید از یک قرارداد باشند', {
              duration: 2000,
            })
          }
        }
      } else {
        var ListToAdd = this.propsRows.filter((x) => x.TblContractId == data.TblContractId)
        // this.ToFacrotList.push(data)
        ListToAdd.forEach((element) => {
          this.ToFacrotList.push(element)
          document.getElementById('check' + element.Id).checked = true
        })
      }
    },
    ToFactor() {
      this.$router.push({ name: 'Factor', params: { Status: 'Add', propstblCustomerProducts: this.ToFacrotList } })
    },
  },
  components: { Card, BnpGrid ,datePicker: VuePersianDatetimePicker},
}
</script>
<style scoped>
.font-smaller {
  font-size: smaller;
}
</style>
<style>
#NoFactor table {
  font-size: small;
}
</style>
